import { Dialog } from '@datacamp/waffles/dialog';
import { Heading } from '@datacamp/waffles/heading';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import React from 'react';

import loadingReportsGif from '../../assets/images/loading_reports.gif';
import loadingWorkbooksGif from '../../assets/images/loading_workbooks.gif';

import GuidesBackButton from './GuidesBackButton';

const LoadingWorkbooksModal: React.FC = () => {
  return (
    <>
      <Dialog.Header>Loading workbooks in the Remote Desktop</Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          In Datacamp’s BI courses, you need to solve exercises using workbooks
          or reports. We have made a Virtual Machine (VM) with a Windows
          environment available to you. This VM has its own file system and
          installation of the BI software available. You can find the name of
          the file that needs to be loaded for every exercise in the instruction
          pane on the left-hand side.
        </Paragraph>
        <Heading size="large">Tableau</Heading>
        <Paragraph>
          For Tableau, you can find the exercise workbooks in the Workbooks
          folder that can be accessed from the Desktop.
        </Paragraph>
        <img
          alt="loading workbooks"
          height="auto"
          src={loadingWorkbooksGif}
          style={{
            marginTop: tokens.spacing.medium,
            marginBottom: tokens.spacing.medium,
          }}
          width="100%"
        />
        <Heading size="large">Power BI</Heading>
        <Paragraph>
          For Power BI, you can find the exercise reports in the Exercises
          folder that can be accessed from the Desktop.
        </Paragraph>
        <img
          alt="loading reports"
          height="auto"
          src={loadingReportsGif}
          style={{ marginTop: tokens.spacing.medium }}
          width="100%"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <GuidesBackButton />
      </Dialog.Footer>
    </>
  );
};

export default LoadingWorkbooksModal;
